module.exports = __webpack_public_path__ + "static/media/red-bus.de60d74b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/red-bus.png
// module id = 916
// module chunks = 0